import PelckmansLogo from '../../sidebar/components/PelckmansLogo';
import User from '../../sidebar/components/User';
import AdminMenu from '../../sidebar/AdminMenu';

export default function PageNavigation() {
  return (
    <aside className="page-navigation">
      <div className="content">
        <div className="top-navigation">
          <PelckmansLogo />
        </div>
        <div className="middle-navigation" />
        <div className="bottom-navigation" data-testid="bottom-navigation">
          <AdminMenu />
          <User />
        </div>
      </div>
    </aside>
  );
}
